module.exports = __webpack_public_path__ + "static/media/logo_qxq.95e33949.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo_qxq.png
// module id = 338
// module chunks = 0